//
//
//
//
//
//
//
//
//

import { toRGB } from './converter'

export default {
  name: 'masker',
  props: {
    color: {
      type: String,
      default: '0, 0, 0'
    },
    opacity: {
      type: Number,
      default: 0.5
    },
    fullscreen: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    style () {
      let color = /,/.test(this.color) ? this.color : toRGB(this.color.replace('#', '')).join(',')
      return {
        backgroundColor: `rgba(${color},${this.opacity})`
      }
    }
  }
}



// WEBPACK FOOTER //
// ./~/vux/src/components/masker/index.vue